import Fab from "@mui/material/Fab"
import Icon from "@mui/material/Icon"
import { RWebShare } from "react-web-share"

export function InviteButton(props: { url: string }): JSX.Element {
  return (
    <RWebShare data={{ url: props.url }}>
      <Fab
        variant="extended"
        color="secondary"
        sx={{
          position: "absolute",
          bottom: 80,
          right: 20,
        }}
      >
        <Icon sx={{ mr: 1 }} children="person_add" />
        Invite
      </Fab>
    </RWebShare>
  )
}
